<template>
  <div class="container">
    <header>
      <nav>
        <div class="nav-grid">
          <div class="nav-item">
            <img src="../assets/theme/Manu.png" alt="" style="float: left;">
          </div>
          <div class="logo">
            <img src="../assets/theme/logo.png" alt="">
          </div>
          <div class="nav-item">
            <img src="../assets/theme/Refresh.png" alt="" style="float: right;">
          </div>
        </div>
      </nav>
    </header>
    <div class="date">
      <div class="date-left" @click="prevResult">
        <img v-if="prevDraw" src="../assets/theme/L.png" alt="">
      </div>
      <div class="date-center">
        <h1>{{ drawDate }}</h1>
      </div>
      <div class="date-right" @click="nextResult">
        <img v-if="nextDraw" src="../assets/theme/R.png" alt="">
      </div>
    </div>
    <div class="banner">
      <a href="https://stocks-vip.com/" target="_blank"><img src="../assets/b1.gif"></a>
    </div>
    <h1>1st place</h1>
    <div class="bar-1">
      <ShowBalls length="5" :results="resultNumbers" result-key="prize_1st" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
    </div>
    <h1>2nd place</h1>
    <div class="bar-2">
      <ShowBalls length="5" :results="resultNumbers" result-key="prize_2nd" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
    </div>
    <div class="banner">
      <a href="https://stocks-vip.com/" target="_blank"><img src="../assets/b2.gif"></a>
    </div>
    <h1>3rd place</h1>
    <div class="rd-3 row no-gutters">
      <div class="rd-box col-4">
        <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="rd-box col-4">
        <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="rd-box col-4">
        <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
    </div>
    <h1> Special</h1>
    <div class="specai row no-gutters">
      <div class="sp-box col-3">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box col-3">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box col-3">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box col-3">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box col-3">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_5" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box col-3">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_6" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box col-3">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_7" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box col-3">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_8" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
    </div>
    <h1>Consulation</h1>
    <div class="consulation row no-gutters">
      <div class="con-box col-3">
        <ShowNumbers length="2" :results="resultNumbers" result-key="consolation_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="con-box col-3">
        <ShowNumbers length="2" :results="resultNumbers" result-key="consolation_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="con-box col-3">
        <ShowNumbers length="2" :results="resultNumbers" result-key="consolation_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="con-box col-3">
        <ShowNumbers length="2" :results="resultNumbers" result-key="consolation_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
    </div>
  </div>
</template>
<script>
import { slotItems } from '@/configs/slot.config.js'
import LottoService from '@/services/lottoService.js'
//import moment from 'moment'
import ShowNumbers from './components/ShowNumbers.vue'
import ShowBalls from './components/ShowBalls.vue'

export default {
  components: {
    ShowBalls,
    ShowNumbers
  },
  data() {
    return {
      currentResult: null,
      currentResultId: null,
      prevDraw: null,
      nextDraw: null,
      today: this.$moment().format("YYYY-MM-DD"),
      IntervalReload: null,
      updateTime: null,
      setTimeoutToshow: null,
      setTimeoutToSuccess: null,
      distance: 30, // ระยะห่างของการออกแต่ล่ะเลข (วินาที)
      slotCounting: null
    }
  },
  watch: {
    startSpin(newVal, oldVal) {
      if(newVal && newVal !== oldVal) {
        this.updateTime = new Date().getTime()
      }
    },
    startShow(newVal, oldVal) {
      if(newVal && newVal !== oldVal) {
        this.calProcess()
      }
    },
    endTime(newVal, oldVal) {
      if(newVal && newVal !== oldVal) {
        this.updateTime = new Date().getTime()
      }
    },
    prize1st(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.updateTime = new Date().getTime()
      }
    },
    prize2nd(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.updateTime = new Date().getTime()
      }
    }
  },
  computed: {
    drawDate() {
      if (!this.currentResult)
        return '-'

      let date = this.$moment(this.currentResult.lotto_date)
      return date.format("YYYY-MM-DD") + `[${date.format("ddd")}]`
    },
    resultNumbers() {
      if (this.currentResult !== null) {
        return this.currentResult.results
      } else {
        return null
      }
    },
    updateCode() {
      return this.updateTime
    },
    startSpin() {
      if (this.currentResult !== null) {
        return this.currentResult.start_spin
      }
      return null
    },
    startShow() {
      if (this.currentResult !== null && this.currentResult.show_2nd) {
        return this.currentResult.show_2nd
      }
      return null
    },
    endTime() {
      if (this.currentResult !== null && this.currentResult.show_1st) {
        return this.currentResult.show_1st
      }
      return null
    },
    prize1st() {
      if (this.currentResult !== null && this.resultNumbers['prize_1st']) {
        return this.resultNumbers['prize_1st']
      }
      return null
    },
    prize2nd() {
      if (this.currentResult !== null && this.resultNumbers['prize_2nd']) {
        return this.resultNumbers['prize_2nd']
      }
      return null
    }
  },
  methods: {
    getResult(draw) {
      LottoService.getResult(draw).then((response) => {
        if (response.status === 'success') {
          this.currentResult = response.data
          this.prevDraw = response.prev
          this.nextDraw = response.next
        }
      })
    },
    prevResult() {
      this.currentResultId = this.prevDraw
      this.getResult(this.prevDraw)
    },
    nextResult() {
      this.currentResultId = this.nextDraw
      this.getResult(this.nextDraw)
    },
    reloadResult() {
      this.getResult(this.currentResultId)
    },
    calProcess() {
      if(this.setTimeoutToshow !== null) {
        clearTimeout(this.setTimeoutToshow)
      }
      if(this.currentResult.show_2nd) {
        // ยังไม่ถึงเวลาแสดงค่าแรก
        if(this.$moment().isBefore(this.currentResult.show_2nd)) {
          this.slotCounting = null
          let diff = this.$moment(this.currentResult.show_2nd).diff(this.$moment(), 'milliseconds')
          this.setTimeoutToshow = setTimeout(() => {
            this.calProcess()
          }, diff)
        // ถึงเวลาแสดงค่าแรก
        }else{
          // ระยะเวลาหลังจากแสดงค่าแรก
          let diff = this.$moment().diff(this.$moment(this.currentResult.show_2nd), 'milliseconds')
          let slotIndex = Math.floor(Math.abs(diff) / (this.distance*1000))
          this.updateTime = new Date().getTime()
          if (slotIndex < slotItems.length) {
            this.slotCounting = slotItems[slotIndex]
          } else {
            this.slotCounting = slotItems[slotItems.length - 1]
          }
        }
      }
    },
  },
  created() {
    //console.log('created')
    this.getResult(this.currentResultId)
    this.IntervalReload = setInterval(() => {
      this.reloadResult()
    }, 45000)
  },
  beforeDestroy() {
    clearInterval(this.IntervalReload)
    clearTimeout(this.setTimeoutToshow)
    clearTimeout(this.setTimeoutToSuccess)
  }
}
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

#app {
  width: 100%;

  .container {
    padding: 0;
    background: url('../assets/theme/ss.png') no-repeat center bottom;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    padding-bottom: 50px;

    header {
      width: 100%;
      margin-bottom: 20px;

      nav {
        .nav-grid {
          display: flex;
          justify-content: space-between;

          .logo {
            img {
              width: 200px;
            }
          }

          .nav-item {
            padding: 5px;

            img {
              width: 20px;
            }
          }
        }
      }
    }

    .date {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      justify-content: center;

      .date-left, .date-right {
        width: 25px;
        img {
          width: 20px;
        }
      }
      .date-left {
        text-align: right;
      }
      .date-center {
        border: 2px solid #222;
        width: 230px;

        h1 {
          margin: 0;
          font-size: 22px;
          text-align: center;
          line-height: 1;
          padding: 2px 0;
        }
      }
    }

    .banner {
      text-align: center;
      margin-bottom: 15px;

      img {
        width: calc(100% - 10px);
      }
    }

    h1 {
      font-size: 24px;
      text-align: center;
      margin-bottom: 2px;
    }

    .bar-1 {
      margin-bottom: 15px;

      .ball-boxs {
        margin: 0 auto;

        >span {
          text-align: center;
          border: 3px solid #1e0396;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 2px;

          border-radius: 45px;
          width: 270px;
          height: 58px;
        }

        img {
          width: 50px;
          margin: 1px;
        }

        h1 {
          font-size: 40px;
          letter-spacing: 20px;
        }
      }
    }

    .bar-2 {
      margin-bottom: 15px;

      .ball-boxs {
        margin: 0 auto;

        >span {
          text-align: center;
          border: 3px solid #8f0416;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 2px;

          border-radius: 40px;
          width: 245px;
          height: 53px;
        }

        img {
          width: 45px;
          margin: 1px;
        }

        h1 {
          font-size: 40px;
          letter-spacing: 15px;
        }
      }
    }

    .rd-3 {
      width: 95%;
      margin: 0 auto;
      margin-bottom: 10px;

      .rd-box {

        >div {
          align-items: center;
          background-color: #FFF;
          border: 1px solid #000;
          margin: 0 2px;
          height: 35px;

          .wloading {
            img {
              width: 13px;
              margin: 0 1px;
            }
          }
        }
      }
    }

    .specai {
      width: 95%;
      margin: 0 auto;
      margin-bottom: 10px;

      .sp-box {
        >div {
          align-items: center;
          background-color: #FFF;
          border: 1px solid #000;
          margin: 0 2px 4px;
          height: 30px;

          h1 {
            font-size: 20px;
          }

          .wloading {
            img {
              width: 10px;
              margin: 0 1px;
            }
          }
        }
      }
    }

    .consulation {
      width: 95%;
      margin: 0 auto;
      margin-bottom: 15px;

      .con-box {
        >div {
          align-items: center;
          background-color: #FFF;
          border: 1px solid #000;
          margin: 0 2px;
          height: 35px;

          h1 {
            font-size: 24px;
          }

          .wloading {
            img {
              width: 14px;
              margin: 0 1px;
            }
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 400px) {
  #app {
    .container {
      padding-bottom: 100px;
      border: 3px solid #222;

      header {
        nav {
          .nav-grid {
            .logo {
              img {
                width: 300px;
              }
            }
            .nav-item {
              img {
                width: 25px;
              }
            }
          }
        }
      }

      .date {
        .date-left, .date-right {
          width: 30px;
          img {
            width: 25px;
          }
        }
        .date-left {
          text-align: right;
        }
        .date-center {
          border: 2px solid #000;
          width: 300px;

          h1 {
            margin: 0;
            font-size: 28px;
            text-align: center;
            line-height: 1;
            padding: 2px 0;
          }
        }
      }

      h1 {
        font-size: 28px;
        margin-bottom: 4px;
      }

      .bar-1 {
        .ball-boxs {
          >span {
            border-radius: 55px;
            width: 320px;
            height: 68px;
          }

          img {
            width: 60px;
            margin: 1px;
          }

          h1 {
            font-size: 50px;
            letter-spacing: 20px;
          }
        }
      }

      .bar-2 {
        .ball-boxs {
          >span {
            border-radius: 50px;
            width: 295px;
            height: 63px;
          }

          img {
            width: 55px;
            margin: 1px;
          }

          h1 {
            font-size: 50px;
            letter-spacing: 15px;
          }
        }
      }

      .rd-3 {
        margin-bottom: 15px;

        .rd-box {

          >div {
            height: 40px;

            h1 {
              font-size: 30px;
            }

            .wloading {
              img {
                width: 14px;
                margin: 0 1px;
              }
            }
          }
        }
      }

      .specai {
        margin-bottom: 15px;

        .sp-box {
          >div {
            height: 35px;

            h1 {
              font-size: 24px;
            }

            .wloading {
              img {
                width: 11px;
              }
            }
          }
        }
      }

      .consulation {
        .con-box {
          >div {
            height: 38px;

            h1 {
              font-size: 30px;
            }

            .wloading {
              img {
                width: 15px;
              }
            }
          }
        }
      }
    }

  }
}

@media only screen and (min-width: 500px) {
  #app {
    .container {
      max-width: 100%;

      header {
        nav {
          .nav-grid {
            .logo {
              img {
                width: 350px;
              }
            }
            .nav-item {
              img {
                width: 30px;
              }
            }
          }
        }
      }

      .date {
        .date-left, .date-right {
          width: 30px;
          img {
            width: 25px;
          }
        }
        .date-center {
          width: 350px;

          h1 {
            font-size: 32px;
          }
        }
      }

      h1 {
        font-size: 30px;
      }

      .bar-1 {
        .ball-boxs {
          >span {
            border-radius: 60px;
            width: 345px;
            height: 73px;
          }

          img {
            width: 65px;
            margin: 1px;
          }

          h1 {
            font-size: 55px;
          }
        }
      }

      .bar-2 {
        .ball-boxs {
          >span {
            border-radius: 55px;
            width: 325px;
            height: 68px;
          }

          img {
            width: 60px;
            margin: 1px;
          }

          h1 {
            font-size: 55px;
          }
        }
      }

      .rd-3 {

        .rd-box {

          >div {
            height: 45px;

            h1 {
              font-size: 32px;
            }

            .wloading {
              img {
                width: 15px;
                margin: 0 2px;
              }
            }
          }
        }
      }

      .specai {

        .sp-box {
          >div {
            height: 40px;

            h1 {
              font-size: 26px;
            }

            .wloading {
              img {
                width: 12px;
                margin: 0 2px;
              }
            }
          }
        }
      }

      .consulation {
        .con-box {
          >div {
            height: 45px;

            h1 {
              font-size: 32px;
            }

            .wloading {
              img {
                margin: 0 2px;
              }
            }
          }
        }
      }
    }

  }
}

@media only screen and (min-width: 600px) {
  #app {
    .container {
      max-width: 100%;

      header {
        nav {
          .nav-grid {
            display: block;
            text-align: center;
            .logo {
              img {
                width: 450px;
              }
            }
            .nav-item {
              display: none;
            }
          }
        }
      }

      .date {
        .date-left, .date-right {
          width: 35px;
          img {
            width: 30px;
          }
        }
        .date-center {
          width: 500px;

          h1 {
            font-size: 36px;
          }
        }
      }

      .banner {
        img {
          width: 550px;
        }
      }

      h1 {
        font-size: 36px;
      }

      .bar-1 {
        .ball-boxs {
          >span {
            border-radius: 65px;
            width: 394px;
            height: 78px;
          }

          img {
            width: 70px;
            margin: 1px 4px;
          }

          h1 {
            font-size: 60px;
          }
        }
      }

      .bar-2 {
        .ball-boxs {
          >span {
            border-radius: 65px;
            width: 360px;
            height: 73px;
          }

          img {
            width: 65px;
            margin: 1px 3px;
          }

          h1 {
            font-size: 55px;
          }
        }
      }

      .rd-3 {
        .rd-box {
          >div {
            h1 {
              letter-spacing: 2px;
            }
          }
        }
      }

      .specai {
        .sp-box {
          >div {
            h1 {
              letter-spacing: 2px;
            }
          }
        }
      }

      .consulation {
        .con-box {
          >div {
            h1 {
              letter-spacing: 2px;
            }
          }
        }
      }

    }

  }
}

@media only screen and (min-width: 700px) {
  #app {
    .container {

      .rd-3 {
        .rd-box {
          >div {
            height: 50px;

            .wloading {
              img {
                width: 20px;
                margin: 0 5px;
              }
            }
          }
        }
      }

      .specai {

        .sp-box {
          >div {
            height: 45px;

            .wloading {
              img {
                width: 18px;
                margin: 0 4px;
              }
            }
          }
        }
      }

      .consulation {
        .con-box {
          >div {
            height: 50px;

            .wloading {
              img {
                width: 20px;
                margin: 0 5px;
              }
            }
          }
        }
      }
    }

  }
}

@media only screen and (min-width: 800px) {
  #app {
    .container {

      .rd-3 {
        .rd-box {
          >div {
            .wloading {
              img {
                width: 25px;
                margin: 0 5px;
              }
            }
          }
        }
      }

      .specai {

        .sp-box {
          >div {
            .wloading {
              img {
                width: 20px;
                margin: 0 4px;
              }
            }
          }
        }
      }

      .consulation {
        .con-box {
          >div {
            .wloading {
              img {
                width: 25px;
                margin: 0 5px;
              }
            }
          }
        }
      }
    }

  }
}

@media only screen and (min-width: 900px) {
  #app {
    .container {
      max-width: 960px;

      header {
        nav {
          .nav-grid {
            .logo {
              img {
                width: 550px;
              }
            }
          }
        }
      }

      .date {
        .date-left, .date-right {
          width: 35px;
          img {
            width: 30px;
          }
        }
        .date-center {
          width: 550px;
          border: 3px solid #222;

          h1 {
            font-size: 36px;
          }
        }
      }

      .banner, .bar-1, .bar-2, .rd-3, .specai, .consulation {
        margin-bottom: 25px;
      }

      .rd-3, .specai, .consulation {
        width: 800px;
      }

    }

  }
}
</style>
